<template>
    <div class="flex">
        <div v-if="item.check_result1 === 1" class="h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"></div>
        <div v-else-if="item.check_result1 === 2" class="h-3 w-3 bg-[#E63415] rounded-sm mr-1"></div>
        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

        <div v-if="item.check_result2 === 1" class="h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"></div>
        <div v-else-if="item.check_result2 === 2" class="h-3 w-3 bg-[#FF6600] rounded-sm mr-1"></div>
        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

        <div v-if="item.check_result3 === 1" class="h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"></div>
        <div v-else-if="item.check_result3 === 2" class="h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"></div>
        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

        <div v-if="item.check_result4 === 1" class="h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"></div>
        <div v-else-if="item.check_result4 === 2" class="h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"></div>
        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

        <div v-if="item.check_result5 === 1" class="h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"></div>
        <div v-else-if="item.check_result5 === 2" class="h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"></div>
        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

        <div v-if="item.check_result6 === 1" class="h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"></div>
        <div v-else-if="item.check_result6 === 2" class="h-3 w-3 bg-[#4167F0] rounded-sm mr-1"></div>
        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AlertStatusIndicators',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
});
</script> 